import { SessionState, NavState } from './_state.interfaces';

/**
 * セッションステート初期値
 */
export const sessionInitialState: SessionState = {
  loading: false,
  auth: {
    login: false,
    token: null
  },
  userInfo: null,
  message: null,
  appId: null,
  admin: false,
  userName: '',
};

/**
 * ナビバーステート初期値
 */
export const navInitialState: NavState = {
  showMenu: true,
  showCart: true,
  openSideNav: false
};
